import EmailOutlined from "@mui/icons-material/EmailOutlined";
import PhoneOutlined from "@mui/icons-material/PhoneOutlined";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { colors } from "healthex-common/colors";
import styled from "styled-components";
import { ListContainer } from "./HXMobilePage.styles";
export const EmailIcon = styled(EmailOutlined) `
    color: ${colors.black_light};
    width: 24px;
    height: 24px;
`;
export const PhoneIcon = styled(PhoneOutlined) `
    color: ${colors.black_light};
    width: 24px;
    height: 24px;
`;
export const InfoIcon = styled(InfoOutlined) `
    color: ${colors.black_light};
    width: 24px;
    height: 24px;
`;
export const ContactInfoContainer = styled(ListContainer) `
    background-color: ${colors.sunset_8};
    padding: 8px;
`;
